import { useCallback, useEffect, useRef, useState } from 'react';

interface UseGridLoadingStateInput {
  isLoadingDocumentations: boolean;
  isLoadingDirectories: boolean;
  isLoadingSearch: boolean;
  isLoadingFilters: boolean;
  searchPhrase: string;
}

interface UseGridLoadingStateResult {
  isDocumentationListLoading: () => boolean;
  shouldShowGridLoadingOverlay: boolean;
  shouldShowNoRowsOverlayLoading: boolean;
  setFilteredFileResetDialogOpen: (isOpen: boolean) => void;
}

export function useGridLoadingState({
  isLoadingDocumentations,
  isLoadingDirectories,
  isLoadingSearch,
  isLoadingFilters,
  searchPhrase,
}: UseGridLoadingStateInput): UseGridLoadingStateResult {
  const [isFilteredFileResetDialogOpen, setFilteredFileResetDialogOpen] =
    useState(false);

  const isDocumentationDataLoading =
    isLoadingDocumentations ||
    isLoadingDirectories ||
    isLoadingSearch ||
    isLoadingFilters;

  const isDocumentationListLoadingRef = useRef(true);

  useEffect(() => {
    isDocumentationListLoadingRef.current = isDocumentationDataLoading;
  }, [isDocumentationDataLoading]);

  const isDocumentationListLoading = useCallback(
    () => isDocumentationListLoadingRef.current,
    []
  );

  const isGridLoading =
    isLoadingDocumentations ||
    isLoadingDirectories ||
    isLoadingFilters ||
    (isLoadingSearch && searchPhrase?.length > 0);

  const shouldShowGridLoadingOverlay =
    !isFilteredFileResetDialogOpen && isGridLoading;

  const shouldShowNoRowsOverlayLoading =
    !isFilteredFileResetDialogOpen &&
    (isLoadingDocumentations ||
      isLoadingDirectories ||
      isLoadingFilters ||
      (isLoadingSearch && searchPhrase?.length > 0));

  return {
    isDocumentationListLoading,
    shouldShowGridLoadingOverlay,
    shouldShowNoRowsOverlayLoading,
    setFilteredFileResetDialogOpen,
  };
}
